export const SETTINGS = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost',
  GET_LOGIN_REQUEST_STATUS_POLLER_INTERVAL: 2000,
  CODE_VALID_TIME_MS: 60000,
  CODES_TO_GENERATE: 4,
  NETVISOR_MOBILE_URL: 'https://netvisor.fi/tuote/mobiili/netvisor-app-login/',
};
